import Body from "../../../../../../../material/skeleton/Body";
import Footer from "../../../../../../../material/skeleton/Footer";
import NotifyManualValidation from "./NotifyManualValidation";
import Box from "@mui/material/Box";
import {Button, CircularProgress, Link} from "@mui/material";
import {Call} from "@mui/icons-material";
import {useEffect, useRef} from "react";
import NotifyValidationRequired from "./NotifyValidationRequired";
import useQualityInspectionRepository from "../../../../../../../repository/emergency/useQualityInspectionRepository";
import isNull from "../../../../../../../mixin/isNull";
import LoadingData from "../../common/LoadingData";
import Typography from "@mui/material/Typography";
import parameter from "../../../../../../../enum/parameter";

export default function ({qualityInspectionId, clientId, interventionId, orderId}) {
    const qualityInspectionRepository = useQualityInspectionRepository();
    /** @type QualityInspection */
    const qualityInspection = qualityInspectionRepository.findOneById(qualityInspectionId).select();
    const callLink = useRef();
    const interval = useRef();

    useEffect(() => {
        qualityInspectionRepository.findOneById(qualityInspectionId).exec();

        interval.current = setInterval(() => {
            qualityInspectionRepository.findOneById(qualityInspectionId).exec(false);
        }, 5000);

        return () => clearInterval(interval.current);
    }, []);

    const handleCallClick = () => {
        callLink.current.click();
    }

    if (isNull(qualityInspection)) return <LoadingData/>;

    return (
        <>
            <Body>
                <Box mt={2}>
                    <NotifyManualValidation/>
                </Box>
                <Box mt={2}>
                    <NotifyValidationRequired/>
                </Box>
                {
                    !qualityInspection.isQuotationValidate()
                        ? (
                            <>
                                <Box mt={10} display={"flex"} justifyContent="center">
                                    <Button
                                        startIcon={<Call/>}
                                        variant={"contained"} sx={{width: "80%"}}
                                        onClick={handleCallClick}
                                        data-test="button-call-quotation-validation"
                                    >
                                        Contactez nous
                                    </Button>
                                </Box>
                                <Link
                                    ref={callLink}
                                    visibility={"hidden"}
                                    href={`tel:${process.env.REACT_APP_QUOTATION_VALIDATION_PHONE}`}
                                />
                            </>
                        )
                        : null
                }

                {
                    qualityInspection.isQuotationValidate()
                    && qualityInspection.isWaitingPrescriberValidation()
                        ? (
                            <Typography mt={10} variant="h6" textAlign={"center"}>
                                Nous attendons la validation de l'assistance, veuillez patienter.
                            </Typography>
                        )
                        : null
                }
            </Body>
            <Footer>
                <Button
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    variant="contained"
                    fullWidth
                    size={"large"}
                >
                    <CircularProgress size={20} color={"inherit"}/>
                </Button>
            </Footer>
        </>
    )
}